import { styled } from "@mui/material";
import { rem } from "polished";

export const AmountLabel = styled("span")`
  color: ${(props) => props.theme.palette.primary.contrastText};
  font-size: ${rem(13)};
`;
